import { render, staticRenderFns } from "./PaywallPlans.vue?vue&type=template&id=1f09ac20&scoped=true&"
import script from "./PaywallPlans.vue?vue&type=script&lang=ts&"
export * from "./PaywallPlans.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallPlans.vue?vue&type=style&index=0&id=1f09ac20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09ac20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1f09ac20', component.options)
    } else {
      api.reload('1f09ac20', component.options)
    }
    module.hot.accept("./PaywallPlans.vue?vue&type=template&id=1f09ac20&scoped=true&", function () {
      api.rerender('1f09ac20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/PaywallPlans.vue"
export default component.exports